import * as React from "react"
import { Link } from "gatsby"
// styles
const pageStyles = {
  color: "#232129",
  padding: 96,
  fontFamily: "-apple-system, Roboto, sans-serif, serif",
}
const headingStyles = {
  marginTop: 0,
  marginBottom: 64,
  maxWidth: 320,
}
const headingAccentStyles = {
  color: "#663399",
}
const paragraphStyles = {
  marginBottom: 48,
}

// markup
const IndexPage = () => {
  return (
    <main style={pageStyles}>
      <title>App Offline</title>
      <h1 style={headingStyles}>
        Careers at Bajaj Electricals
        <br />
        <br />
        <br />
        <span style={headingAccentStyles}>You are offline </span>
      </h1>
      <p style={paragraphStyles}>
        Please connect to the internet to search for new opportunities. 
      </p>
     <p style={paragraphStyles}>
      <Link to="/">Go home</Link>
      </p>
    </main>
  )
}

export default IndexPage
